import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cabecalho-marca',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cabecalho-marca.component.html',
  styleUrls: ['./cabecalho-marca.component.css']
})
export class CabecalhoMarcaComponent {
  @Input() logo = '';
  @Input() iniciais = 'PJ';
  @Input() nome = 'Ponto JWM';
  @Input() agora = new Date();
  @Input() subtitulo = 'Sistema administrativo e registrador de ponto web';
}
